/* tslint:disable */
import { AppConfig } from './model';

export const config: AppConfig = {
    'apiGatewayUrl' : 'apigateway/',
    'onBoardingAppDomain': isAbsoluteUrl(MICROAPPS_URLS['onboarding']) ? MICROAPPS_URLS['onboarding'] : window.location.origin + MICROAPPS_URLS['onboarding'],
    'dashboardAppDomain': isAbsoluteUrl(MICROAPPS_URLS['dashboard']) ? MICROAPPS_URLS['dashboard'] : window.location.origin + MICROAPPS_URLS['dashboard'],
    'classAppDomain': isAbsoluteUrl(MICROAPPS_URLS['class']) ? MICROAPPS_URLS['class'] : window.location.origin + MICROAPPS_URLS['class'],
    'adminAppDomain' : isAbsoluteUrl(MICROAPPS_URLS['admin']) ? MICROAPPS_URLS['admin'] : window.location.origin + MICROAPPS_URLS['admin'],
    'focAppDomain': isAbsoluteUrl(MICROAPPS_URLS['foc']) ? MICROAPPS_URLS['foc'] : window.location.origin + MICROAPPS_URLS['foc'],
    'expiredClassReactivationPeriod' : 30, //In days,
    'customReqHeaders' : {
        'appVersion' : {
            'key' : 'cambridgeone-app-version',
            'value' : 'v2'
        },
        'userRole' : {
            'key' : 'user-role'
        },
        'userId' : {
            'key' : 'user-id'
        }
    },
    'disableLaunchBtnTimeSpan' : 3600000, // 60min
    'mosaicProductsClassification': {
        'rl-25-a1': {
            'rl-25-a2-reading': {
                'skill': 'reading'
            },
            'rl-25-a2-listening': {
                'skill': 'listening'
            }
        },
        'rl-25-a2': {
            'rl-25-a2-reading': {
                'skill': 'reading'
            },
            'rl-25-a2-listening': {
                'skill': 'listening'
            }
        },
        'rl-25-b1': {
            'rl-25-b1-reading': {
                'skill': 'reading'
            },
            'rl-25-b1-listening': {
                'skill': 'listening'
            }
        },
        'rl-25': {
            'rl-25-reading': {
                'skill': 'reading'
            },
            'rl-25-listening': {
                'skill': 'listening'
            }
        },
        'mosaic': {
            'mosaic-reading': {
                'skill': 'reading'
            },
            'mosaic-listening': {
                'skill': 'listening'
            }
        },
        'prlna2': {
            'prlna2rea': {
                'skill': 'reading'
            },
            'prlna2lit': {
                'skill': 'listening'
            }
        },
        'prlnb1': {
            'prlnb1rea': {
                'skill': 'reading'
            },
            'prlnb1lit': {
                'skill': 'listening'
            }
        },
        'prlnb2': {
            'prlnb2rea': {
                'skill': 'reading'
            },
            'prlnb2lit': {
                'skill': 'listening'
            }
        },
        'prlnc1': {
            'prlnc1rea': {
                'skill': 'reading'
            },
            'prlnc1lit': {
                'skill': 'listening'
            }
        }
    }
};

function isAbsoluteUrl(url) {
    let pat = /(^https?:\/\/)|(^\/\/)/i;
    return pat.test(url);
}